import moment from "moment";
const MAX_DAYS = 33;
const INIT_DAYS = 7;

(function (angular) {
  "use strict";

  angular
    .module("fleetviewApp")
    .component("complianceGroup", {
      template: require("./complianceGroup.html"),
      controller: ComplianceGroupController
    });

  ComplianceGroupController.$inject = [
    "$scope",
    "$state",
    "$q",
    "$stateParams",
    "$location",
    "$timeout",
    "LayoutService",
    "Drivers",
    "Vehicles",
    "DriverGroups",
    "VehicleGroups",
    "cacheService",
    "UserProvider",
    "RouteReporterAPI"
  ];

  function ComplianceGroupController($scope, $state, $q, $stateParams, $location, $timeout, LayoutService, Drivers, Vehicles, DriverGroups, VehicleGroups, cacheService, UserProvider, RouteReporterAPI) {
    let vm = this;
    vm.backToGroups = backToGroups;
    vm.viewSelectedVehicles = viewSelectedVehicles;
    vm.onFilterKeyUp = onFilterKeyUp;
    vm.filterItems = filterItems;
    vm.loadMoreItems = loadMoreItems;
    vm.showCompliance = showCompliance;
    vm.toggleSelectedId = toggleSelectedId;
    vm.openDatePickerPopup = openDatePickerPopup;
    vm.selectAll = selectAll;
    vm.selectNone = selectNone;
    vm.exportCSV = exportCSV;
    vm.showRoutes = showRoutes;
    vm.backToGroup = backToGroup;
    vm.$onInit = init;
    vm.leftPanelWidth = leftPanelWidth;
    vm.getStartDateString = getStartDateString;
    vm.getEndDateString = getEndDateString;
    vm.shouldShowCount = shouldShowCount;
    vm.onSearchSettingsChange = onSearchSettingsChange;
    vm.alerts = [];
    vm.closeAlert = closeAlert;

    function init() {
      vm.panelWidth = "500px";
      vm.isLoading = false;
      vm.groupName = "";
      vm.dateFormat = "MM/dd/yyyy";
      vm.isFromPopupOpen = false;
      vm.isToPopupOpen = false;
      vm.allItems = [];
      vm.filteredItems = [];
      vm.shownItems = [];
      vm.ids = [];
      vm.groupInfo = $stateParams;
      vm.values = [];
      vm.groupIds = [];
      vm.counter = 0;

      // don't allow coming to this state with no groupid set.  todo: this might be better in a resolve on the state.
      if ($stateParams.groupId == null) {
        return vm.backToGroups();
      }

      //get params
      vm.groupType = $stateParams.groupType;

      // handle the to/from dates - never allow them to be set greater than MAX_DAYS days apart
      $scope.$watch(() => vm.toDate, (newValue) => _handleToDateChanged(newValue));
      $scope.$watch(() => vm.fromDate, (newValue) => _handleFromDateChanged(newValue));

      vm.groupId = $stateParams.groupId; // id or 'all'
      const parsedGroupId = parseInt($stateParams.groupId) || 0;
      vm.groupIds = [parsedGroupId];

      var settings = cacheService.getSearchSettings();
      //If the settings retrieved were for a different vehicle/driver group, do not apply them
      if (!sameGroup(settings)) {
        settings = null;
      }
      if (settings) {
        vm.fromDate = moment(settings.startDate).toDate();
        vm.toDate = moment(settings.endDate).toDate();
        vm.hideQuestionable = settings.noQuestionableRoutes;
        vm.hideNoOOr = !settings.includeRoutesWithNoOorMiles;
        vm.idchanged = settings.counter;
        vm.filter = settings.filter;
        vm.filterItems(vm.filter);
      } else {
        vm.toDate = moment().endOf("day").toDate();
        vm.fromDate = moment(vm.toDate).subtract(INIT_DAYS, "days").startOf("day").toDate();
        vm.hideQuestionable = true;
        vm.hideNoOOr = false;
      }

      let promises = [];

      var currentUser = UserProvider.getUser();
      var targetAccount = null;
      if (currentUser.supportAccount)
        targetAccount = currentUser.supportAccount.accountId;

      // set group name
      if (vm.groupType === "vehicleGroup" && vm.groupId !== "all") {
        promises.push(VehicleGroups.getById(vm.groupIds[0], targetAccount).then((group) => vm.groupName = group.name));
        promises.push(_loadVehicles(vm.groupIds));

      } else if (vm.groupType === "driverGroup" && vm.groupId !== "all") {
        promises.push(DriverGroups.getById(vm.groupIds[0], targetAccount).then((group) => vm.groupName = group.name));
        promises.push(_loadDrivers(vm.groupIds));
      }

      if (vm.groupType === "vehicleGroup" && $stateParams.groupId === "all") {
        promises.push(_loadVehicles());
        vm.groupName = "All Vehicles";
      }

      if (vm.groupType === "driverGroup" && $stateParams.groupId === "all") {
        promises.push(_loadDrivers());
        vm.groupName = "All Driver";
      }

      vm.isLoading = true;
      $q.all(promises).finally(() => {
        vm.isLoading = false;
        const allIds = vm.allItems.map(c => c.id);
        if (settings) {
          vm.ids = settings.ids;
          //Must remove all ids that were previously selected, but that no longer exist in allItems
          vm.ids = _.intersection(allIds, vm.ids);
        }
        // order the display items properly - toggled items on top
        vm.filterItems(vm.filter);
      });

    }

    //Are the saved settings for the same vehicle/driver group as the current one in the vm?
    function sameGroup(settings) {
      if (!settings) {
        return false;
      }
      var vmIdType = (vm.groupType === "vehicleGroup" ? "vehicle" : "driver");
      return settings.groupId[0] === vm.groupIds[0] && settings.idType === vmIdType;
    }

    function onFilterKeyUp(event) {
      if (event.keyCode === 27) {
        vm.filter = null;
        vm.filterItems(vm.filter);
      }
    }

    function closeAlert(index) {
      vm.alerts.splice(index, 1);
    }

    // based on the user input filter and whatever items the user has toggled/selected,
    // show the toggled items in alphabetical order on top
    // and the non-toggled items in alphabetical order underneath
    function filterItems(filter) {
      // filter is cleared
      if (!filter) {
        let toggledItems = [];
        toggledItems = vm.allItems.filter(item => vm.ids.includes(item.id));
        vm.allItems = vm.allItems.filter((item) => !toggledItems.includes(item));

        // sort the toggled items alphabetically by name
        toggledItems.sort(function (x, y) {
          return (x.name < y.name) ? -1 : (x.name > y.name) ? 1 : 0
        });
        // sort the rest of the items alphabetically by name
        vm.allItems.sort(function (x, y) {
          return (x.name < y.name) ? -1 : (x.name > y.name) ? 1 : 0
        });
        // place the toggled items before the rest of the items
        vm.allItems = toggledItems.concat(vm.allItems);
        vm.filteredItems = vm.allItems;

      } else {
        let filterUpperCase = filter.toUpperCase();
        vm.filteredItems = vm.allItems.filter(c => c.name != null
          && (c.name.toUpperCase().indexOf(filterUpperCase) !== -1 || c.itemId.toString().indexOf(filterUpperCase) !== -1));

      }

      // show first 20 items
      vm.shownItems = vm.filteredItems.slice(0, 20);
      // make sure to let the list know that the items in it changed so it can do the correct infinite scroll logic
      $scope.$emit("list:filtered");
    }

    function loadMoreItems() {
      //console.log("showing more items: " + vm.shownItems.length + ":" + (vm.shownItems.length + 10));

      let newItems = vm.filteredItems.slice(vm.shownItems.length, vm.shownItems.length + 10);
      vm.shownItems = vm.shownItems.concat(newItems);
    }

    function leftPanelWidth() {
      return LayoutService.getLeftPanelWidth();
    }

    /**
     * Closes the compliance tab
     */


    /**
     * Hide compliance panel but keep routes
     */

    function showCompliance() {
      LayoutService.openLeftHandPanel("500px");
    }

    /**
     * Returns to the list of vehicle/driver groups state
     */
    function backToGroups() {
      $state.go($stateParams.parentState, {
        "group": vm.groupInfo.groupType
      });
    }

    function showRoutes() {
      //console.log("getting data with the following options ", vm.settings, $stateParams.childState);
      $state.go($stateParams.childState, {
        settings: vm.settings
      });
    }

    function getStartDateString() {
      var settings = cacheService.getSearchSettings();
      if (settings) {
        return moment(settings.startDate).format("MM/DD/YYYY");
      }
      return "";
    }

    function getEndDateString() {
      var settings = cacheService.getSearchSettings();
      if (settings) {
        return moment(settings.endDate).format("MM/DD/YYYY");
      }
      return "";
    }

    function shouldShowCount() {
      return vm.ids.length > 0 && !$state.is("main.compliance.group.routes");
    }

    function backToGroup() {
      $state.go($stateParams.parentState, {
        "groupType": vm.groupInfo.groupType,
        "groupId": vm.groupInfo.groupId
      });

    }
    /**
     * Toggles the selection of the vehicle or driver
     *
     * @param {integer} id Identifier of the vehicle or driver to toggle selection
     *
     * @memberOf ComplianceGroupController
     */
    function toggleSelectedId(id) {
      vm.counter++;
      let idx = vm.ids.indexOf(id);

      // isolate the toggled item
      let itemIndex = vm.allItems.findIndex(c => c.id == id);
      let item = vm.allItems[itemIndex];
      vm.allItems.splice(itemIndex, 1);

      // item is being unchecked
      if (idx > -1) {
        vm.ids.splice(idx, 1);
        // move it to the back of the list containing all items
        vm.allItems.push(item);
      } else {
        vm.ids.push(id);
        // move it to the front of the list containing all items
        vm.allItems.unshift(item);
      }
    }

    /**
     *  Open a date picker on the screen
     *
     * @param {string} whichPicker Describes which date picker to open.  This can be "from" or "to".
     *
     * @memberOf ComplianceGroupController
     */
    function openDatePickerPopup(whichPicker) {
      if (whichPicker === "from") {
        vm.isFromPopupOpen = true;
      } else {
        vm.isToPopupOpen = true;
      }
    }

    /**
     * Uses the current set filter parameters to query the compliance service to return a list of all compliance routes.
     *
     * @returns a Promise object representing the completion of querying the service and setting the returned routes on the model.
     */
    function viewSelectedVehicles() {
      console.log('in viewSelectedVehicles in complianceGroup controller');
      onSearchSettingsChange();
      showRoutes();
    }


    function onSearchSettingsChange() {
      vm.settings = {
        startDate: moment(vm.fromDate).startOf("day").toDate(),
        endDate: moment(vm.toDate).startOf("day").toDate(), // NOTE: Sproc 'SPR_PrescribedRoute_GetByVehicle' filters by 'day', not datetime.
        idType: vm.groupType === "vehicleGroup" ? "vehicle" : "driver",
        noQuestionableRoutes: vm.hideQuestionable,
        includeRoutesWithNoOorMiles: !vm.hideNoOOr,
        ids: vm.ids,
        idchanged: vm.counter,
        groupId: vm.groupIds
      };
      vm.settings.filter = vm.filter;
      cacheService.setSearchSettings(vm.settings);
    }


    /**
     * Select all filtered vehicle or drivers
     *
     * @memberOf ComplianceGroupController
     */
    function selectAll() {
      let itemsToSelect = vm.filteredItems.filter(item => !vm.ids.includes(item.id));

      for (let i = 0; i < itemsToSelect.length; i++) {
        vm.toggleSelectedId(itemsToSelect[i].id);
      }
    }

    /**
     * Unselect all filtered vehicle or drivers
     *
     * @memberOf ComplianceGroupController
     */
    function selectNone() {
      let itemsToRemove = vm.filteredItems.filter(item => vm.ids.includes(item.id));

      for (let i = 0; i < itemsToRemove.length; i++) {
        vm.toggleSelectedId(itemsToRemove[i].id);
      }
    }

    function exportCSV() {
      vm.alerts.push({ msg: "Started export process!", type: "info" });
      let user = JSON.parse(window.sessionStorage["userAuthInfo"]);
      var accountId = user.accountId;
      var currentUser = UserProvider.getUser();
      if (currentUser.supportAccount) {
        accountId = currentUser.supportAccount.accountId;
      }

      var data = {
        accountId: accountId,
        startDate: moment(vm.fromDate).startOf("day").toDate(),
        endDate: moment(vm.toDate).startOf("day").toDate(),
        groupId: vm.groupIds,
        idType: vm.groupType === "vehicleGroup" ? "vehicle" : "driver",
        idchanged: vm.counter,
        ids: vm.filteredItems.map(c => c.id),
        includeRoutesWithNoOorMiles: !vm.hideNoOOr,
        isOor: false,
        noCoords: false,
        noQuestionableRoutes: true,
        oorCost: 0,
        order: "asc",
        pageNumber: 1,
        pageSize: 10,
        sort: ""
      };
      RouteReporterAPI.post("api/report/export", data, null)
        .then(function successCallback(response) {
          vm.alerts.splice(0, 1);
          vm.alerts.push({ msg: "Report has been exported, Please check your email!", type: "info" });
          timeoutAlert();
        }, function errorCallback(response) {
          vm.alerts.splice(0, 1);
          vm.alerts.push({ msg: "Export failed, please try again!", type: "danger" });
          timeoutAlert();
        });
    }

    function timeoutAlert() {
      $timeout(() => { vm.closeAlert(0); }, 5 * 1000);
    }

    function _loadDrivers(groupIds = null) {
      var currentUser = UserProvider.getUser();
      var targetAccount = null;
      if (currentUser.supportAccount) {
        targetAccount = currentUser.supportAccount.accountId;
      }
      return Drivers.getDrivers(groupIds, null, null, targetAccount).then(drivers => {
        vm.allItems = drivers.map(c => {
          return {
            name: c.name,
            id: c.id,
            itemId: c.driverId
          };
        });
      });
    }

    function _loadVehicles(groupIds = null) {
      var currentUser = UserProvider.getUser();
      var targetAccount = null;
      if (currentUser.supportAccount) {
        targetAccount = currentUser.supportAccount.accountId;
      }
      // TODO: add ability to filter out vehicles with no routes
      return Vehicles.getVehicleList(groupIds, targetAccount).then(vehicles => {
        vm.allItems = vehicles.map(c => {
          return {
            name: c.name,
            id: c.id,
            itemId: c.vehicleId
          };
        });
      });
    }

    function _handleFromDateChanged(newFromDate) {
      if (newFromDate == null) return;

      let toDate = moment(vm.toDate);
      let fromDate = moment(newFromDate);

      if (fromDate.isAfter(toDate)) vm.toDate = fromDate.toDate();

      // Don't allow fromDate to be more then MAX_DAYS days before toDate
      if (toDate.diff(fromDate, "days") > MAX_DAYS) vm.toDate = fromDate.add(MAX_DAYS, "days").toDate();
    }

    function _handleToDateChanged(newToDate) {
      if (newToDate == null) return;

      let toDate = moment(newToDate);
      let fromDate = moment(vm.fromDate);

      // don't allow fromdate to after toDate
      if (toDate.isBefore(fromDate)) vm.fromDate = toDate.toDate();

      // Don't allow fromDate to be more then MAX_DAYS days before toDate
      if (toDate.diff(fromDate, "days") > MAX_DAYS) vm.fromDate = toDate.subtract(MAX_DAYS, "days").toDate();
    }
  }
})(window.angular);



// WEBPACK FOOTER //
// ./app/compliance/complianceGroup.controller.js